module.exports = __webpack_public_path__ + "assets/94a59754bca402daddc7465f46050f84.png";